import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  post
} from './api'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css'
import 'swiper/css/swiper.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import uploadFile from "../app.js";
import public_ from './components/public/public' //引用文件
Vue.prototype.Public = public_ //挂载到Vue实例上面

import calendar from './calendar/calendar.js';
Vue.prototype.Calendar = calendar //挂载到Vue实例上面
import conmonFun from './components/utils/commonFun.js' // 到处全局方法
Vue.prototype.$common = conmonFun //挂载到Vue实例上面
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
import '@/style/index.less' // 导入覆盖样式文件


Vue.prototype.$uploadFile = uploadFile;
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
import axios from "axios"
Vue.prototype.post = post
if (localStorage.getItem("token-qzb")) {
  axios.defaults.headers.common["token"] = localStorage.getItem("token-qzb");
}
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)




Vue.config.productionTip = false
import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')